module.exports = __webpack_public_path__ + "static/img/xl11.0a7294a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl11.png
// module id = bw/J
// module chunks = 73